export default __webpack_public_path__ + "static/media/new-time.cc6ddfeb.svg";